// extracted by mini-css-extract-plugin
module.exports = {"base":"Title_base___asct","secondary":"Title_secondary__e_a2a","primary":"Title_primary__dDPKq"};